module.exports = __webpack_public_path__ + "static/media/meme_4.6ea0260a.png";